import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Page } from '../models';

export type AppointmentNotificationType =
  'NEW_APPOINTMENT' |
  'APPOINTMENT_UPDATED' |
  'COUNTDOWN' |
  'REMINDER';

export type AppointmentNotificationStatus =
  'SENT' |
  'FAILED' |
  'SKIPPED';

export interface AppointmentNotificationHistory {
  id: number;
  appointmentId: number;
  commercialId: number;
  commercialName: string;
  tierId: number;
  tierName: string;
  type: AppointmentNotificationType;
  title: string;
  message: string;
  appointmentDate: string;
  status: AppointmentNotificationStatus;
  firebaseMessageId: string;
  createdAt: string;
  sentAt: string;
  errorMessage: string;
}

export interface AppointmentNotificationHistoryStatistics {
  total: number;
  sent: number;
  failed: number;
  skipped: number;
}

@Injectable()
export class AppointmentNotificationHistoryService {

  notificationUrl =
    environment.dns + 'api/appointment-notifications/';

  constructor(private http: HttpClient) {
  }

  getHistory(
    page: number,
    size: number,
    startDate?: Date,
    endDate?: Date
  ): Observable<Page<AppointmentNotificationHistory>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (startDate) {
      params = params.set(
        'startDate',
        this.formatRequestDate(startDate)
      );
    }

    if (endDate) {
      params = params.set(
        'endDate',
        this.formatRequestDate(endDate)
      );
    }

    return this.http.get<Page<AppointmentNotificationHistory>>(
      this.notificationUrl + 'history',
      { params }
    );
  }

  getStatistics(
    startDate?: Date,
    endDate?: Date
  ): Observable<AppointmentNotificationHistoryStatistics> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set(
        'startDate',
        this.formatRequestDate(startDate)
      );
    }

    if (endDate) {
      params = params.set(
        'endDate',
        this.formatRequestDate(endDate)
      );
    }

    return this.http.get<AppointmentNotificationHistoryStatistics>(
      this.notificationUrl + 'history/statistics',
      { params }
    );
  }

  private formatRequestDate(date: Date): string {
    const year = date.getFullYear();
    const month =
      ('0' + (date.getMonth() + 1)).slice(-2);
    const day =
      ('0' + date.getDate()).slice(-2);

    return year + '-' + month + '-' + day;
  }
}
